import { gql } from '@apollo/client';

const TOUCH = gql`
  mutation touchHealthCoach {
    touchHealthCoach {
      token
      id
    }
  }
`;

const GENERATE_CIRCLE_SO_CALLBACK = gql`
  mutation generateCircleSoCallback {
    generateCircleSoCallback {
      callback
      mustAcceptTerms
    }
  }
`;

const REPLY_TO_CONVERSATION = gql`
  mutation healthCoachReplyToConversation(
    $conversationId: String!
    $customerId: Int
    $status: String!
    $assignedTo: Int
    $text: String
    $attachments: [ConversationThreadReplyAttachments]
    $userId: Int!
    $athenaId: String
    $isDraft: Boolean
  ) {
    healthCoachReplyToConversation(
      athenaId: $athenaId
      data: { conversationId: $conversationId, customerId: $customerId, status: $status, assignedTo: $assignedTo, text: $text, attachments: $attachments, userId: $userId, isDraft: $isDraft }
    ) {
      ok
      redirectTo
    }
  }
`;

const ADD_NOTE_TO_CONVERSATION = gql`
  mutation providerNoteToConversation($conversationId: String!, $status: String!, $assignedTo: Int, $text: String, $attachments: [ConversationThreadReplyAttachments], $userId: Int!) {
    providerNoteToConversation(data: { conversationId: $conversationId, status: $status, assignedTo: $assignedTo, text: $text, attachments: $attachments, userId: $userId }) {
      ok
    }
  }
`;

const REASSIGN_CONVERSATION = gql`
  mutation providerReassignConversation($conversationId: String!, $assignedTo: Int) {
    providerReassignConversation(conversationId: $conversationId, assignedTo: $assignedTo) {
      ok
    }
  }
`;

const CHANGE_CONVERSATION_STATUS = gql`
  mutation providerChangeStatusConversation($conversationId: String!, $status: String!, $userId: Int) {
    providerChangeStatusConversation(conversationId: $conversationId, status: $status, userId: $userId) {
      ok
    }
  }
`;

const CHANGE_MULTI_CONVERSATIONS_STATUS = gql`
  mutation providerChangeStatusMultiConversations($conversationId: [String]!, $status: String!, $userId: Int) {
    providerChangeStatusMultiConversations(conversationId: $conversationId, status: $status, userId: $userId) {
      ok
    }
  }
`;

const CHANGE_PROFILE = gql`
  mutation providerSaveProfile($patientFacingName: String, $bio: String, $question1: String, $question2: String, $education: String, $experience: String, $startingYear: String) {
    providerSaveProfile(patientFacingName: $patientFacingName, bio: $bio, question1: $question1, question2: $question2, education: $education, experience: $experience, startingYear: $startingYear) {
      ok
    }
  }
`;

const SEND_SMS_TO_PATIENT = gql`
  mutation healthCoachSendSMS($id: String!, $message: String!, $appointmentId: String, $note: String) {
    healthCoachSendSMS(id: $id, message: $message, appointmentId: $appointmentId, note: $note) {
      ok
      customError
    }
  }
`;

const ADD_APPOINTMENT_NOTE = gql`
  mutation healthCoachAddAppointmentNote($appointmentId: String!, $note: String!) {
    healthCoachAddAppointmentNote(appointmentId: $appointmentId, note: $note) {
      ok
    }
  }
`;

const IMPERSONATE = gql`
  mutation impersonateProvider($id: String!) {
    impersonateProvider(id: $id) {
      token
    }
  }
`;

const REPORT_NO_SHOW = gql`
  mutation healthCoachReportNoShow($inviteeUri: String!) {
    healthCoachReportNoShow(inviteeUri: $inviteeUri) {
      ok
    }
  }
`;
const ADD_HEALTH_COACH_FORM_TO_LIBRARY = gql`
  mutation addHealthCoachFormToLibrary($formId: String!, $isActive: Boolean!, $isFavorite: Boolean!) {
    addHealthCoachFormToLibrary(formId: $formId, isActive: $isActive, isFavorite: $isFavorite) {
      ok
    }
  }
`;

const EDIT_HEALTH_COACH_FORM_LIBRARY = gql`
  mutation editHealthCoachFormLibrary($id: String!, $isActive: Boolean, $isFavorite: Boolean, $isDeleted: Boolean) {
    editHealthCoachFormLibrary(id: $id, isActive: $isActive, isFavorite: $isFavorite, isDeleted: $isDeleted) {
      ok
    }
  }
`;

const MARK_INXS_AS_READ = gql`
  mutation markInxsMessageAsRead($inxsId: String!) {
    markInxsMessageAsRead(inxsId: $inxsId) {
      ok
    }
  }
`;

const APPEND_CHART_ALERT = gql`
  mutation appendChartAlert($athenaId: String!, $noteToAdd: String!) {
    appendChartAlert(athenaId: $athenaId, noteToAdd: $noteToAdd) {
      ok
    }
  }
`;



const SNOOZE_CONVERSATION = gql`
  mutation snoozeConversation($athenaId: String!, $conversationId: String!, $snoozeUntil: String!) {
    snoozeConversation(athenaId: $athenaId, conversationId: $conversationId, snoozeUntil: $snoozeUntil) {
      ok
    }
  }
`;

const UNSNOOZE_CONVERSATION = gql`
  mutation unsnoozeConversation($conversationId: String!) {
    unsnoozeConversation(conversationId: $conversationId) {
      ok
    }
  }
`;

const GENERATE_WEBTOKEN_FOR_IMPERSONATE = gql`
  mutation generateWebTokenFromHC {
    generateWebTokenFromHC {
      token
    }
  }
`;

const SAVE_HC_STICKY_NOTE = gql`
  mutation addHealthCoachStickyNote($athenaId: String!, $note: String) {
    addHealthCoachStickyNote(athenaId: $athenaId, note: $note) {
      ok
    }
  }
`;

const DELETE_HEALTH_COACH_VISIT_SUMMARY = gql`
  mutation healthCoachDeleteVisitSummary($id: String!) {
    healthCoachDeleteVisitSummary(id: $id) {
      ok
    }
  }
`;

const UPSERT_HEALTH_COACH_VISIT_SUMMARY = gql`
  mutation healthCoachUpsertVisitSummary($userId: String!, $calendlyUri: String!, $summary: String!, $internalNotes: String, $internalForm: String, $id: String, $courseId: String) {
    healthCoachUpsertVisitSummary(userId: $userId, calendlyUri: $calendlyUri, summary: $summary, internalNotes: $internalNotes, internalForm: $internalForm, id: $id, courseId: $courseId) {
      ok
    }
  }
`;

const DELETE_WELLNESS_PLAN = gql`
  mutation healthCoachDeleteWellnessPlan($id: String!) {
    healthCoachDeleteWellnessPlan(id: $id) {
      ok
    }
  }
`;

const UPSERT_WELLNESS_PLAN = gql`
  mutation healthCoachUpsertWellnessPlan($userId: String!, $plan: String, $revisionFromId: String, $internalNotes: String) {
    healthCoachUpsertWellnessPlan(userId: $userId, plan: $plan, revisionFromId: $revisionFromId, internalNotes: $internalNotes) {
      ok
    }
  }
`;

const MARK_CHART_AS_PREPPED = gql`
  mutation markChartAsPrepped($appointmentId: String!, $patientId: String!) {
    markChartAsPrepped(appointmentId: $appointmentId, patientId: $patientId) {
      ok
    }
  }
`;

const UNMARK_CHART_AS_PREPPED = gql`
  mutation unmarkChartAsPrepped($appointmentId: String!, $patientId: String!) {
    unmarkChartAsPrepped(appointmentId: $appointmentId, patientId: $patientId) {
      ok
    }
  }
`;

const INIT_MEMBER_CONVO = gql`
  mutation healthCoachInitMemberConvo($athenaId: String!) {
    healthCoachInitMemberConvo(athenaId: $athenaId) {
      ok
      customError
    }
  }
`;

export {
  IMPERSONATE,
  REPORT_NO_SHOW,
  TOUCH,
  GENERATE_CIRCLE_SO_CALLBACK,
  REPLY_TO_CONVERSATION,
  ADD_NOTE_TO_CONVERSATION,
  REASSIGN_CONVERSATION,
  CHANGE_CONVERSATION_STATUS,
  CHANGE_PROFILE,
  SEND_SMS_TO_PATIENT,
  ADD_HEALTH_COACH_FORM_TO_LIBRARY,
  EDIT_HEALTH_COACH_FORM_LIBRARY,
  MARK_INXS_AS_READ,
  APPEND_CHART_ALERT,
  SNOOZE_CONVERSATION,
  UNSNOOZE_CONVERSATION,
  GENERATE_WEBTOKEN_FOR_IMPERSONATE,
  SAVE_HC_STICKY_NOTE,
  DELETE_HEALTH_COACH_VISIT_SUMMARY,
  UPSERT_HEALTH_COACH_VISIT_SUMMARY,
  DELETE_WELLNESS_PLAN,
  UPSERT_WELLNESS_PLAN,
  ADD_APPOINTMENT_NOTE,
  MARK_CHART_AS_PREPPED,
  UNMARK_CHART_AS_PREPPED,
  CHANGE_MULTI_CONVERSATIONS_STATUS,
  INIT_MEMBER_CONVO
};
